import React, { useRef, useState } from "react";
import styled, { keyframes } from "styled-components";
import innerText from "react-innertext";
import DrippingAnimation from "./DrippingAnimation";
import { CareBraille, FlexDiv, FullScreenDiv } from "./Utilities";
import { CSSTransition } from "react-transition-group";

const fadeOut = keyframes`
from {
	z-index: 100;
	opacity: 1;
}
to {
	opacity: 0;
	z-index: 0;
}
`;

const FullScreenSplash = styled(FullScreenDiv)`
  opacity: 1;
  background: black;
  color: white;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 10rem;
  align-items: center;
  align-content: start;
  justify-content: start;
  & > * {
    margin: 6rem;
  }
  &.splash-exit-active {
    animation: ${fadeOut} 1.5s linear forwards;
  }
`;

const PreserveWhitespaceSpan = styled.span`
  display: inline-block;
  white-space: pre;
`;

const ShortFlexDiv = styled(FlexDiv)`
  width: 25%;
  height: 1%;
  overflow-wrap: break-word;
`;

export function TextSpans(props) {
  const text = innerText(props.children).split(" ");
  return text.map((word, index) => (
    <PreserveWhitespaceSpan key={index}>{word} </PreserveWhitespaceSpan>
  ));
}

function InitialSplashScreen({
  text,
  dripProb,
  animationDuration,
  randomDurationScale,
  animationDelay,
  randomDelayScale,
  setAudioContext,
  ...props
}) {
  const [showSplash, setShowSplash] = useState(true);
  const transitionRef = useRef(null);

  return (
    <CSSTransition
      in={showSplash}
      enter={false}
      timeout={1500}
      classNames="splash"
      unmountOnExit
      nodeRef={transitionRef}
    >
      <FullScreenSplash
        onClick={() => {
          setAudioContext(new AudioContext());
          setShowSplash(false);
        }}
        ref={transitionRef}
      >
        <CareBraille></CareBraille>
        <ShortFlexDiv>
          <DrippingAnimation
            dripProb={dripProb}
            animationDuration={animationDuration}
            randomDurationScale={randomDurationScale}
            animationDelay={animationDelay}
            randomDelayScale={randomDelayScale}
          >
            {text.split(" ").map((word, index) => (
              <PreserveWhitespaceSpan key={index}>
                {word}{" "}
              </PreserveWhitespaceSpan>
            ))}
          </DrippingAnimation>
        </ShortFlexDiv>
      </FullScreenSplash>
    </CSSTransition>
  );
}

export default InitialSplashScreen;
